module.exports = __webpack_public_path__ + "img/568.2638cdfa.png";